module.exports = __webpack_public_path__ + "media/svg-new/icon-edit-1f030f67.svg";